<template>
  <div>
    <b-form @submit.prevent="handleSubmit">
      <b-row class="mb-3 d-md-block">
        <b-col>
          <InputText
            v-model="form.username.data"
            :errors="form.username.errors"
            :placeholder="$t('profile.signUp.main.email')"
          />
        </b-col>
      </b-row>
      <b-row class="mb-3 d-md-block">
        <b-col>
          <InputText
            v-model="form.password.data"
            :errors="form.password.errors"
            type="password"
            autocomplete="current-password"
            :placeholder="$t('profile.signUp.main.password')"
          />
        </b-col>
      </b-row>
      <b-row class="mb-3 d-md-block">
        <b-col>
          <span class="forgot-text" @click="forgotPage">
            {{ $t('profile.logIn.main.forgot') }}
          </span>
        </b-col>
      </b-row>
      <recaptcha class="row justify-content-center" />
      <div class="mt-2">
        <Button width="full" color="green" :submit="true">
          {{ $t('profile.logIn.main.title') }}&nbsp;>
        </Button>
      </div>
    </b-form>
    <ErrorSection v-if="form.error" :error-message="form.message" />
  </div>
</template>

<script>
import InputText from 'UI/InputText';
import Button from 'UI/Button';
import ErrorSection from '@/components/User/Form/ErrorSection';
export default {
  components: {
    InputText,
    Button,
    ErrorSection
  },
  data() {
    return {
      form: {
        error: false,
        message: '',
        username: {
          data: '',
          errors: []
        },
        password: {
          data: '',
          errors: []
        }
      }
    };
  },
  methods: {
    validateEmail() {
      this.form.username.errors = [
        this.form.username.data?.length ? null : this.$t('profile.logIn.main.usernameIsRequired')
      ].filter((value) => value);
    },
    validatePassword() {
      this.form.password.errors = [
        this.form.password.data?.length ? null : this.$t('profile.logIn.main.passwordIsRequired')
      ].filter((value) => value);
    },
    async handleSubmit() {
      this.validateEmail();
      this.validatePassword();
      if (this.form.username.data?.length && this.form.password.data?.length) {
        this.localLogin();
      }
    },
    async localLogin() {
      this.$emit('loading', true);
      await this.loginUser();
      this.$emit('loading', false);
    },
    async loginUser() {
      try {
        const captchaToken = await this.$recaptcha.getResponse();

        await this.$auth.loginWith('local', {
          data: {
            username: this.form.username.data,
            password: this.form.password.data,
            captchaToken
          }
        });

        this.$store.commit('downloads/SET_DOWNLOAD_PERMISSION', []);
        this.$emit('login');
        try {
          await this.$recaptcha.reset();
        } catch (error) {
          console.error('LOGIN', error);
        }
        this.$nuxt.refresh();
      } catch (error) {
        await this.$recaptcha.reset();
        console.error('LOGIN', error);
        this.form.error = true;
        this.form.message =
          error.message === 'invalid_credentials'
            ? this.$t('profile.logIn.main.credentialsError')
            : this.$t('profile.logIn.main.defaultError');
      }
    },
    forgotPage() {
      this.$bvModal.hide('user-modal');
      this.$router.push({ path: this.localePath('login-forgot') });
    }
  }
};
</script>

<style lang="scss" scoped>
.forgot-text {
  cursor: pointer;
  color: $defaultColor;
}
</style>
